import React, { ReactElement, useState } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import AlertMessage from "../../../components/alert/AlertMessage";
import "./UserInviteForm.css";

/** UserInviteForm component:
 * Form to enter email and name. Invites a new user.
 *
 * Props: handleSubmit (function)
 * State: formData {name: string, email: string}
 *        isSubmitValid: boolean.
 *        isSubmitted: boolean- determines when alert should be thrown
 */

interface FormData {
    name: string;
    email: string;
}

const defaultData = {
    name: "",
    email: "",
};

export default function UserInviteForm(): ReactElement {
    const [formData, setFormData] = useState<FormData>(defaultData);
    const [isSubmitValid, setIsSubmitValid] = useState<boolean>(true);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = evt.target;
        setFormData(data => ({
            ...data,
            [name]: value,
        }));
    };
    /** ensures form inputs are not blank */
    function validateInput(): boolean {
        const isFormValid = Object.values(formData).every(field => field.trim() !== "");
        setIsSubmitValid(isFormValid);
        if (!isFormValid) {
            setIsSubmitted(false);
        }
        return isFormValid;
    }

    const submitForm = (evt: React.SyntheticEvent): void => {
        evt.preventDefault();
        if (validateInput()) {
            // const [firstName, lastName = ""] = formData.name.split(" ");
            // const { email, name } = formData;
            // const inviteFormData = {
            //     name,
            //     firstName,
            //     lastName,
            //     email,
            // };
            // handleSubmit(inviteFormData);
            setFormData(defaultData);
            setIsSubmitted(true);
        }
    };

    return (
        <div>
            {!isSubmitValid && (
                <AlertMessage message="Please enter first and last name, and email." variant="danger" />
            )}
            {isSubmitted && (
                <AlertMessage message="User added!" variant="info" />
            )}
            <Form className="UserInviteForm-form" onSubmit={submitForm}>
                <h4>Invite New User</h4>
                <Row>
                    <Col sm>
                        <Form.Group controlId="formInlineName">
                            <Form.Label>Name</Form.Label>
                            {" "}
                            <Form.Control
                                type="text"
                                onChange={handleChange}
                                name="name"
                                value={formData.name}
                            />
                        </Form.Group>
                    </Col>
                    {" "}
                    <Col sm>
                        <Form.Group controlId="formInlineEmail" className="UserInviteForm-email">
                            <Form.Label>Email</Form.Label>
                            {" "}
                            <Form.Control
                                type="email"
                                onChange={handleChange}
                                name="email"
                                value={formData.email}
                            />
                        </Form.Group>
                    </Col>
                    {" "}
                    <Col sm>
                        <Button className="UserInviteForm-button" type="submit">Invite</Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
